var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnerBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "195px",
    height: "165px",
    viewBox: "0 0 195 165",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Components") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cerego-illo-16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(-6.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#6B94B6",
    cx: 36,
    cy: 150,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#6B94B6",
    cx: 19,
    cy: 176,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#A896E6",
    cx: 55,
    cy: 124,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#93B2CA",
    cx: 50,
    cy: 169,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#EFDB8C",
    cx: 117,
    cy: 94,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#EFDB8C",
    cx: 143,
    cy: 81,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#EFDB8C",
    cx: 156,
    cy: 50,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#BAEF8C",
    cx: 188,
    cy: 37,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#78D57B",
    cx: 178,
    cy: 74,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#D7A1D4",
    cx: 97,
    cy: 130,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#898ADA",
    cx: 81,
    cy: 117,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#898ADA",
    cx: 88,
    cy: 88,
    r: 13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerBubbles);
export default __webpack_public_path__ + "static/media/learner-bubbles.b82f9141811ef431db58772ca390d19e.svg";
export { ForwardRef as ReactComponent };